






import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';

@Component
export default class RelationsOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public fixedFilter = this.getTableCfg(this.tableCfg, 'fixedFilter');
}
